import { OnlineProvider } from "@api/enums/Session/OnlineProviderEnum";
import { SessionTypeEnum } from "@api/enums/Session/SessionTypeEnum";
import { Element }from "@api/models/Element"
import { DateTime } from "luxon";
import { setDates } from "../helpers/DatesSetter";
import { AgendaModelInterface } from "../interfaces/agenda/AgendaModelInterface";
import { ElementInterface } from "../interfaces/ElementInterface";
import { SessionOnlineParams } from "../interfaces/session/OnlineParams";

export class AgendaModel extends Element implements AgendaModelInterface {

    parentId: string | null;
    eventId: string;
    title: string;

    /**
     * Dates
     */
    beginAt: DateTime;
    endAt: DateTime;

    description: string;
    areaId: string | null;
    tagsIds: string[];
    orderIndex: number | null;
    groupIds: string[];
    isCommentsUnavailable: boolean;
    onlineProvider: OnlineProvider;
    onlineParams: SessionOnlineParams;

    /**
     * Time states
     */
    isClosed: boolean;
    isStarted: boolean;
    isManualControlled: boolean | null;

    type: SessionTypeEnum | string;
    partnerId: string | null
    needContactsAgreement: boolean;

    constructor(data: ElementInterface, schema = "") {
        super(data, schema, []);

        setDates(this, ['beginAt', 'endAt']);
    }
}